import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AdAccountSettings {
	isPinned?: boolean;
	clientKpi?: string;
	clientBreakdown?: string;
}

interface StoreState {
	adAccountSettings: Record<string, AdAccountSettings>;
	updateAdAccountSettings: (adAccountId: string, settings: Partial<AdAccountSettings>) => void;
	removeAdAccountSettings: (adAccountId: string) => void;
}
const useAdAccountDashboardStore = create<StoreState>()(persist(
	(set) => ({
		adAccountSettings: {},

		// Add an account or update if exists
		updateAdAccountSettings: (adAccountId: string, settings: Partial<AdAccountSettings>) => set((state) => ({
			adAccountSettings: {
				...state.adAccountSettings,
				[adAccountId]: {
					...state.adAccountSettings[adAccountId] || {},
					...settings,
				},
			},
		})),

		// Remove an account
		removeAdAccountSettings: (adAccountId: string) => set((state) => {
			const newSettings = { ...state.adAccountSettings };
			delete newSettings[adAccountId];

			return { adAccountSettings: newSettings };
		}),
	}),
	{
		name:       'adAccountDashboard',
		partialize: ({ adAccountSettings }) => ({ adAccountSettings }),
	},
));

export default useAdAccountDashboardStore;
